import React from 'react';
import VectorDownArrow from '../assets/images/VectorDownArrow.svg';

export default () => {
  return <img src={VectorDownArrow} alt="" />;
};
